import React, { useEffect, useRef, useState } from "react";
import useProgress from "./hooks/useProgress";
import { IconLess, IconMore } from "../../misc/icons";
import useHeader from "~components/Header/hooks/useHeader";
import { initialPath } from "~misc/paths";
import { money } from "~hooks/useHelpers";
import InfoCredit from "~components/Form/infoCredit";
import { useParams } from "react-router-dom";

const CreditProgress = ({
  title,
  buttons,
  utilizado,
  disponivel,
  total,
  setTotal,
  buff,
  input,
  barra,
  limiteMaximo,
  limiteAdicional,
  valuePure,
}) => {
  const { path } = useHeader();
  const {
    totalFormat,
    disponivelFormat,
    utilizadoFormat,
    utilizadoProgressValue,
    updatedProgressValue,
    handleClickLess,
    handleClickMore,
    updatedTotal,
    updatedTotalFormat,
    initialTotalFormat,
    setIsUpdatedMinimal,
    isUpdatedMinimal,
  } = useProgress(utilizado, disponivel, total, setTotal, buff, input, limiteMaximo, limiteAdicional);
  let totalFixo = parseFloat(initialTotalFormat.replace("R$", "").replace(/\./g, "").replace(",", "."));
  const excesso = utilizado - totalFixo > 0 ? utilizado - totalFixo : 0;
  const totalWidth = Math.min(utilizadoProgressValue, 100);
  const excessoWidth = excesso > 0 ? (excesso / totalFixo) * 100 : 0;
  const [stateAdicional, setStateAdicional] = useState(false);
  useEffect(() => {
    if (utilizado > totalFixo) {
      let limite = parseFloat(totalFormat.replace("R$", "").replace(/\./g, "").replace(",", "."));
      if (totalFixo !== utilizado && utilizado !== limite) setStateAdicional(true);
      else setStateAdicional(false);
    } else {
      setStateAdicional(true);
    }
  }, [totalFormat, updatedTotal]);
  const handleClickMoreNoDelay = (e, type) => {
    e.preventDefault();
    console.log(total, utilizado);
    if (utilizado > total) {
      const difference = utilizado - total;
      let value = total + difference + buff;

      if (value < 0) {
        valuePure(value);
      }
      valuePure(value);
    } else {
      let value = total + buff;
      console.log(total, buff);
      if (isUpdatedMinimal) {
        value = Math.ceil(utilizado / buff) * buff;
        setIsUpdatedMinimal(false);
      }
      if (type === "less") {
        let value = total - buff;
        console.log("oii");
        valuePure(value);
      } else {
        valuePure(value);
      }
    }
  };
  return (
    <div className={buttons ? "py-8 border-b-2 border-b-[#D4D4D4]" : "py-8"}>
      <div>
        <h4 className="font-bold text-2xl mb-2">{title}</h4>
      </div>
      {buttons && (
        <div className="flex justify-between mb-5">
          <button
            type="button"
            onClick={(e) => {
              handleClickMoreNoDelay(e, "less");
              if (title === "Limite Votorantim" && updatedTotal <= 0) {
                valuePure(0);
              } else if (title === "Limite Pague Flex" && updatedTotal <= 0) {
                valuePure(0);
              }

              handleClickLess(e);
            }}
          >
            <IconLess />
          </button>
          <button
            type="button"
            onClick={(e) => {
              handleClickMoreNoDelay(e, "more");
              handleClickMore(e);
            }}
          >
            <IconMore />
          </button>
        </div>
      )}
      {barra && (
        <>
          <div className="w-full relative h-6 rounded-full border-2 box-content overflow-hidden">
            <div
              className="transition-all bg-secundaria absolute left-0 top-0 h-full rounded-l-full"
              style={{ width: `${totalWidth}%` }}
            />
            {excessoWidth > 0 && limiteAdicional + totalFixo > updatedTotal && (
              <div
                className="transition-all bg-[#D1E7A7] absolute right-0 top-0 h-full"
                style={{
                  width: `${excessoWidth}%`,
                }}
              />
            )}
            {updatedTotal > 0 && stateAdicional && (
              <div
                className={`transition-all bg-terciaria absolute top-0 right-0 h-full`}
                style={{
                  width: `${updatedProgressValue > 0 ? updatedProgressValue : 0}%`,
                }}
              />
            )}
          </div>
        </>
      )}
      <div className="flex justify-between mt-2">
        <p>
          Utilizado: <strong>{utilizadoFormat}</strong>
        </p>
        {path !== "/" + initialPath + "/carteira/credito/novo" && (
          <div className="text-center">
            <p>
              Disponível: <strong>{disponivelFormat}</strong>
            </p>
          </div>
        )}
        <p className="text-right">
          {title === "Saldo Vloz" ? "Total Atual " : "Limite Atual"}: <strong>{initialTotalFormat}</strong> <br />
          {(updatedTotal === 0 || !stateAdicional) && (
            <>
              {limiteAdicional != null && limiteAdicional > 0 && (
                <p className="flex items-center gap-x-2 justify-end">
                  <InfoCredit text="Limite adicional temporário para emergências" bg="blue" />
                  Limite adicional: <strong>{money(limiteAdicional)}</strong>
                </p>
              )}
            </>
          )}
          {updatedTotal !== 0 && stateAdicional && (
            <>
              <span>
                <strong>
                  {updatedTotal > 0 ? " + " : " - "}
                  <p className={updatedTotal > 0 ? "text-terciaria inline" : "text-[#FF2E00] inline"}>
                    {updatedTotalFormat}
                  </p>
                </strong>
              </span>
              <br />
              <strong className="text-xl mt-2 text-terciaria pt-1 border-t-2 block">
                <span className="limiteSolicitado"> Limite Solicitado: {totalFormat}</span>
              </strong>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default CreditProgress;
